export { default } from './Reset2Factor';
